import React, { useEffect, useState } from 'react'

import { Collapse } from 'antd'
import { isString } from 'lodash'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { getAssistantMaccsInternshipWithContexts } from '../../../utils/api/assistant'
import InternshipStatePellet from '../../shared/InternshipStatePellet'
import MaccsInternshipItem from './MaccsInternshipItem'
import { ACCEPTED, ACCEPTED_UNMANAGED, SCHEDULE_ADDED, SCHEDULE_TO_VALIDATE, SCHEDULE_VALIDATED } from '../../../utils/constants'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'

import '../../../assets/index.scss'

const Panel = Collapse.Panel

const InternshipItemsContainer = ({ filter, onInternshipSelect }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [internships, setInternships] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (isString(filter)) {
      setLoading(true)
      getAssistantMaccsInternshipWithContexts(user, user.assistant, { filter, contexts: ['validation-document'] }).then(({ data }) => {
        setInternships(data)
        setLoading(false)
      })
    }
  }, [filter, user.id])

  const handleSelectInternship = id => {
    onInternshipSelect(internships.filter(i => i.id === id)[0])
  }

  return (
    <Collapse bordered={false} accordion style={loading ? { minHeight: '70vh' } : {}}>
      {loading && <div className='loading-ring' />}
      {!loading && internships.map(i => {
        const start = moment(i.startDate).format('DD/MM/YYYY')
        const end = moment(i.endDate).format('DD/MM/YYYY')
        const institution = i.institution === null ? t('Undefined institution') : i.institution.name
        const disabled = ![ACCEPTED, SCHEDULE_ADDED, SCHEDULE_VALIDATED, SCHEDULE_TO_VALIDATE, ACCEPTED_UNMANAGED].includes(i.state)

        const title = (
          <div className='flex-column'>
            {institution}<br />

            {t('From') + ' ' + start + ' ' + t('to') + ' ' + end}<br />

            <InternshipStatePellet internship={i} showLabel />
          </div>
        )

        return (
          <Panel header={title} key={i.id} disabled={disabled}>
            {!disabled &&
              <MaccsInternshipItem
                id={i.id}
                internship={i}
                onInternshipSelect={handleSelectInternship}
              />}
          </Panel>
        )
      })}
    </Collapse>
  )
}

export default InternshipItemsContainer
